import { NgModule } from '@angular/core';
import { ModuleWithProviders } from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Routes, RouterModule, Route, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './auth.service';


/**
 * MESC Components
 */
import { MESCComponent } from './components/mesc/mesc.component';
import { MescAdministrationComponent } from './components/mesc/administration/administration.component';
import { MaintenanceComponent } from './components/mesc/administration/maintenance/maintenance.component';
import { SecurityComponent } from './components/mesc/administration/security/security.component';
import { UsersComponent } from './components/mesc/administration/security/users/users.component';
import { GroupsComponent } from './components/mesc/administration/security/groups/groups.component';
import { PlantsComponent } from './components/mesc/administration/maintenance/plants/plants.component';
import { ProgramsComponent } from './components/mesc/administration/maintenance/programs/programs.component';
import { ZonesComponent } from './components/mesc/administration/maintenance/zones/zones.component';
import { SubzoneComponent } from './components/mesc/administration/maintenance/subzone/subzone.component';
import { TitleComponent } from './components/mesc/administration/maintenance/title/title.component';
import { PlantProgramComponent } from './components/mesc/administration/maintenance/plant-program/plant-program.component';
import { ProgramStyleComponent } from './components/mesc/administration/maintenance/program-style/program-style.component';
import { ModelYearComponent } from './components/mesc/administration/maintenance/model-year/model-year.component';

/**
 * CAMTL Components
 */
import { CamtlComponent } from './components/camtl/camtl.component';

// Administration
import { CamtlAdministrationComponent } from './components/camtl/administration/administration.component';
import { CamtlMaintenanceComponent } from './components/camtl/administration/maintenance/maintenance.component';
import { CamtlSecurityComponent } from './components/camtl/administration/security/security.component';
import { ColsAdminComponent } from './components/camtl/administration/security/cols-admin/cols-admin.component';
import { SuperUserComponent } from './components/camtl/administration/security/super-user/super-user.component';
import { CamtlReportsComponent } from './components/camtl/administration/reports/reports.component';
import { CamtlAdminContactsComponent } from './components/camtl/administration/maintenance/camtl-admin-contacts/camtl-admin-contacts.component';
import { CamtlProjectsComponent } from './components/camtl/administration/maintenance/camtl-projects/camtl-projects.component';
import { ProgramSetupComponent } from './components/camtl/administration/maintenance/program-setup/program-setup.component';
import { CamtlSystemsComponent } from './components/camtl/administration/maintenance/systems/systems.component';
import { ManageDateTemplateComponent } from './components/camtl/administration/maintenance/manage-date-template/manage-date-template.component';
import { TimingChartControlComponent } from './components/camtl/administration/maintenance/timing-chart-control/timing-chart-control.component';

// CAMTL Timing Charts
import { TimingChartsComponent } from './components/camtl/timing-charts/timing-charts.component';
import { FunctionalViewComponent } from './components/camtl/timing-charts/functional-view/functional-view.component';

// CAMTL Workflow
import { WorkflowInboxComponent } from './components/camtl/workflow/workflow-inbox.component';

// Master Tool List
import { MasterToolListComponent } from './components/camtl/master-tool-list/master-tool-list.component';

//Master Tool List Configuration
import { ConfigurationComponent } from './components/camtl/master-tool-list/configuration/configuration.component';
import { SystemLayoutComponent } from './components/camtl/master-tool-list/configuration/system-layout/system-layout.component';
import { BuildToolsComponent } from './components/camtl/master-tool-list/configuration/build-tools/build-tools.component';
import { FurnishedEquipmentToolsComponent } from './components/camtl/master-tool-list/configuration/furnished-equipment-tools/furnished-equipment-tools.component';
import { WeldgunDesignComponent } from './components/camtl/master-tool-list/configuration/weldgun-design/weldgun-design.component';
import { LegacyToolsComponent } from './components/camtl/master-tool-list/configuration/legacy-tools/legacy-tools.component';

//Master Tool List Detail
import { DetailComponent } from './components/camtl/master-tool-list/detail/detail.component';
import { SystemLayoutsComponent } from './components/camtl/master-tool-list/detail/system-layout/system-layout.component';
import { CellsComponent } from './components/camtl/master-tool-list/detail/cells/cells.component';
import { StationsComponent } from './components/camtl/master-tool-list/detail/stations/stations.component';
import { ToolsComponent } from './components/camtl/master-tool-list/detail/tools/tools.component';
import { KitsComponent } from './components/camtl/master-tool-list/detail/kits/kits.component';

import { ListComponent } from './components/camtl/master-tool-list/list/list.component';

// Contacts
import { CamtlContactsComponent } from './components/camtl/camtl-contacts/camtl-contacts.component';
import { CamtlProgramContactsComponent } from './components/camtl/camtl-contacts/camtl-program-contacts/camtl-program-contacts.component';
import { CamtlProjectContactsComponent } from './components/camtl/camtl-contacts/camtl-project-contacts/camtl-project-contacts.component';
import { CamtlSourceContactsComponent } from './components/camtl/camtl-contacts/camtl-source-contacts/camtl-source-contacts.component';
import { CamtlZoneContactsComponent } from './components/camtl/camtl-contacts/camtl-zone-contacts/camtl-zone-contacts.component';

// Parameter Management 
import { ParameterManagementComponent } from './components/camtl/parameter-management/parameter-management.component';
import { ControlPanelComponent } from './components/camtl/parameter-management/control-panel/control-panel.component';
import { FurnishedEquipmentComponent } from './components/camtl/parameter-management/furnished-equipment/furnished-equipment.component';
import { KitComponent } from './components/camtl/parameter-management/kit/kit.component';
import { ToolComponent } from './components/camtl/parameter-management/tool/tool.component';
import { WeldgunComponent } from './components/camtl/parameter-management/weldgun/weldgun.component';
import { ApprovalComponent } from './components/camtl/approval/approval.component';


/**
 * CGP Components
 */
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

/**
 * TNTS Components
 */
import { TntComponent } from './components/tnt/tnt.component';

//  Administration
import { TntAdministrationComponent } from './components/tnt/administration/administration.component';
import { TntMaintenanceComponent } from './components/tnt/administration/maintenance/maintenance.component';
import { TntSecurityComponent } from './components/tnt/administration/security/security.component';
import { CreateToolComponent } from './components/tnt/create-tool/create-tool.component';
import { ToolIdentificationMatrixComponent } from './components/tnt/administration/tool-identification-matrix/tool-identification-matrix.component';
import { ZoneSubZoneTitleComponent } from './components/tnt//administration/zone-sub-zone-title/zone-sub-zone-title.component';
import { TransferToolsComponent } from
  './components/tnt//administration/transfer-tools/transfer-tools.component';
import { ToolOwnershipComponent } from
  './components/tnt//administration/tool-ownership/tool-ownership.component';
import { ArchiveToolsComponent } from
  './components/tnt//administration/archive-tools/archive-tools.component';
import { ToolTeamcenterLinkComponent } from './components/tnt/administration/tool-teamcenter-link/tool-teamcenter-link.component';


@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.authService.isClaimValid(state.url);
  }
}



export const PanelbarRoutes: Routes = [
  {
    path: '',
    redirectTo: '/MESC', pathMatch: 'full',
  },
  {
    path: 'MESC',
    component: MESCComponent,
    canActivate: [AuthGuard],
    data: { breadcrumb: "MESC" },
    children: [
      {
        path: 'Administration',
        component: MescAdministrationComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "Administration" },
        children: [
          {
            path: 'Maintenance',
            component: MaintenanceComponent,
            data: { breadcrumb: "Maintenance" },
            children: [
              {
                path: '',
                redirectTo: 'Plants', pathMatch: 'full',
              },
              {
                path: 'Plants',
                component: PlantsComponent,
                data: { breadcrumb: "Plants" },
              },
              {
                path: 'Programs',
                component: ProgramsComponent,
                data: { breadcrumb: "Programs" },
              },
              {
                path: 'Zones',
                component: ZonesComponent,
                data: { breadcrumb: "Zones" },
              },
              {
                path: 'SubZone',
                component: SubzoneComponent,
                data: { breadcrumb: "SubZone" },
              },
              {
                path: 'Title',
                component: TitleComponent,
                data: { breadcrumb: "Title" },
              },
              {
                path: 'Plant-Program',
                component: PlantProgramComponent,
                data: { breadcrumb: "Plant-Program" },
              },
              {
                path: 'Program-Style',
                component: ProgramStyleComponent,
                data: { breadcrumb: "Program Style" },
              },
              {
                path: 'Model-Year',
                component: ModelYearComponent,
                data: { breadcrumb: "Model Year" },
              },
              {
                path: 'ZoneSubZoneTitle',
                component: ZoneSubZoneTitleComponent,
                data: { breadcrumb: "Manage Zone/SubZone/Title" },
              },
            ],
          },
          {
            path: 'Security',
            component: SecurityComponent,
            data: { breadcrumb: "Security" },
            children: [
              {
                path: '',
                redirectTo: 'Users', pathMatch: 'full',
              },
              {
                path: 'Users',
                data: { breadcrumb: "Users" },
                component: UsersComponent
              },
              {
                path: 'Groups',
                component: GroupsComponent,
                data: { breadcrumb: "Groups" },
              }
            ],
          },
        ]
      },
      {
        path: 'CAMTL',
        component: CamtlComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "CAMTL" },
        // canActivate: [AuthGuard],
        children: [
          {
            path: 'MasterToolList', component: MasterToolListComponent,
            data: { breadcrumb: "Master Tool List" },
            children: [
              {
                path: '',
                redirectTo: 'Configuration', pathMatch: 'full',
              },
              {
                path: 'Configuration',
                component: ConfigurationComponent,
                data: { breadcrumb: "Configuration" },
                children: [
                  {
                    path: '',
                    redirectTo: 'SystemLayout', pathMatch: 'full',
                  },
                  {
                    path: 'SystemLayout', component: SystemLayoutComponent, data: { breadcrumb: "System Layout" },
                  },
                  {
                    path: 'BuildTools', component: BuildToolsComponent, data: { breadcrumb: "Build Tools" },
                  },
                  {
                    path: 'FurnishedEquipmentTools', component: FurnishedEquipmentToolsComponent, data: { breadcrumb: "Furnished Equipment Tools" },
                  },
                  {
                    path: 'LegacyTools', component: LegacyToolsComponent, data: { breadcrumb: "Legacy Tools" },
                  }
                ]
              },
              {
                path: 'Detail',
                component: DetailComponent,
                data: { breadcrumb: "Detail" },
                children: [
                  {
                    path: '', redirectTo: 'SystemLayout', pathMatch: 'full'
                  },
                  {
                    path: 'SystemLayout', component: SystemLayoutsComponent, data: { breadcrumb: "System Layout" }
                  },
                  {
                    path: 'SystemLayout/:id', component: SystemLayoutsComponent, data: { breadcrumb: "System Layout" }
                  },
                  {
                    path: 'SystemLayout?ParentId=:ParentId', component: SystemLayoutsComponent, data: { breadcrumb: "System Layout" }
                  },
                  {
                    path: 'SystemLayout/:id?ParentId=:ParentId', component: SystemLayoutsComponent, data: { breadcrumb: "System Layout" }
                  },
                  {
                    path: 'Cells', component: CellsComponent, data: { breadcrumb: "Cells" }
                  },
                  {
                    path: 'Cells/:id', component: CellsComponent, data: { breadcrumb: "Cells" }
                  },
                  {
                    path: 'Cells?ParentId=:ParentId', component: CellsComponent, data: { breadcrumb: "Cells" }
                  },
                  {
                    path: 'Cells/:id?ParentId=:ParentId', component: CellsComponent, data: { breadcrumb: "Cells" }
                  },
                  {
                    path: 'Stations', component: StationsComponent, data: { breadcrumb: "Stations" }
                  },
                  {
                    path: 'Stations/:id', component: StationsComponent, data: { breadcrumb: "Stations" }
                  },
                  {
                    path: 'Stations?ParentId=:ParentId', component: StationsComponent, data: { breadcrumb: "Stations" }
                  },
                  {
                    path: 'Stations/:id?ParentId=:ParentId', component: StationsComponent, data: { breadcrumb: "Stations" }
                  },
                  {
                    path: 'Tools', component: ToolsComponent, data: { breadcrumb: "Tools" }
                  },
                  {
                    path: 'Tools/:id', component: ToolsComponent, data: { breadcrumb: "Tools" }
                  },
                  {
                    path: 'Tools?ParentId=:ParentId', component: ToolsComponent, data: { breadcrumb: "Tools" }
                  },
                  {
                    path: 'Tools/:id?ParentId=:ParentId', component: ToolsComponent, data: { breadcrumb: "Tools" }
                  },
                  {
                    path: 'Kits', component: KitsComponent, data: { breadcrumb: "Kits" },
                  },
                  {
                    path: 'Kits/:id', component: KitsComponent, data: { breadcrumb: "Kits" },
                  },
                  {
                    path: 'Kits?ParentId=:ParentId', component: KitsComponent, data: { breadcrumb: "Kits" },
                  },
                  {
                    path: 'Kits/:id?ParentId=:ParentId', component: KitsComponent, data: { breadcrumb: "Kits" },
                  }
                ]
              },
              {
                path: 'List', component: ListComponent, data: { breadcrumb: "List" }
              }
            ]
          },
          {
            path: 'TimingCharts', component: TimingChartsComponent, data: { breadcrumb: "Timing Charts" },
            children: [
              {
                path: '',
                redirectTo: 'FunctionalView', pathMatch: 'full'
              },
              {
                path: 'FunctionalView', component: FunctionalViewComponent, data: { breadcrumb: "Functional View" }
              },
            ]

          },
          {
            path: 'WorkflowInbox', component: WorkflowInboxComponent, data: { breadcrumb: "Workflow Inbox" }
          },
          {
            path: 'Approval/:systemId', component: ApprovalComponent, data: { breadcrumb: "Approval" }
          },
          {
            path: 'Contacts', component: CamtlContactsComponent, data: { breadcrumb: "Contacts" },
            children: [
              {
                path: '', redirectTo: 'ProgramContacts', pathMatch: 'full'
              },
              {
                path: 'ProgramContacts', component: CamtlProgramContactsComponent, data: { breadcrumb: "Program Contacts" },
              },
              {
                path: 'ProjectContacts', component: CamtlProjectContactsComponent, data: { breadcrumb: "Project Contacts" },
              },
              {
                path: 'ZoneContacts', component: CamtlZoneContactsComponent, data: { breadcrumb: "Zone Contacts" },
              },
              {
                path: 'SourceContacts', component: CamtlSourceContactsComponent, data: { breadcrumb: "Source Contacts" },
              },
            ]
          },
          {
            path: 'Administration',
            component: CamtlAdministrationComponent,
            canActivate: [AuthGuard],
            data: { breadcrumb: "Administration" },
            children: [
              {
                path: 'Maintenance', component: CamtlMaintenanceComponent, data: { breadcrumb: "Maintenance" },
                children: [
                  {
                    path: '',
                    redirectTo: 'FunctionContacts', pathMatch: 'full',
                  },
                  {
                    path: 'FunctionContacts', component: CamtlAdminContactsComponent, data: { breadcrumb: "Function Contacts" },
                  },
                  {
                    path: 'DateTemplate', component: ManageDateTemplateComponent, data: { breadcrumb: "Manage Date Template" },
                  },
                  {
                    path: 'ProgramSetup', component: ProgramSetupComponent, data: { breadcrumb: "Program Setup" },
                  },
                  {
                    path: 'Projects', component: CamtlProjectsComponent, data: { breadcrumb: "Projects" },
                  },
                  {
                    path: 'TimingChartControl', component: TimingChartControlComponent, data: { breadcrumb: 'Timing Chart Control' }
                  },
                  {
                    path: 'Systems', component: CamtlSystemsComponent, data: { breadcrumb: "Systems" },
                  },
                ]
              },
              {
                path: 'Security', component: CamtlSecurityComponent, data: { breadcrumb: "Security" },
                children: [
                  {
                    path: '',
                    redirectTo: 'SuperUsers', pathMatch: 'full',
                  },
                  {
                    path: 'SuperUsers',
                    canActivate: [AuthGuard],
                    component: SuperUserComponent, data: { breadcrumb: "Super Users" },
                  },
                ]
              },
              {
                path: 'ParameterManagement', component: ParameterManagementComponent, data: { breadcrumb: "Parameter Management" },
                children: [
                  {
                    path: '',
                    redirectTo: 'Kit', pathMatch: 'full',
                  },
                  // {
                  //   path: 'ControlPanel', component: ControlPanelComponent, data: { breadcrumb: "Control Panel" },
                  // },
                  // {
                  //   path: 'FurnishedEquipment', component: FurnishedEquipmentComponent, data: { breadcrumb: "Furnished Equipment" },
                  // },
                  {
                    path: 'Kit', component: KitComponent, data: { breadcrumb: "Kit" },
                  },
                  {
                    path: 'Tool', component: ToolComponent, data: { breadcrumb: "Tool" },
                  },
                  // {
                  //   path: 'Weldgun', component: WeldgunComponent, data: { breadcrumb: "Weldgun" },
                  // },

                ]
              },
              {
                path: 'Reports', component: CamtlReportsComponent, data: { breadcrumb: "Reports" }
              }
            ]
          },
        ]
      },
      {
        path: 'TNTS',
        component: TntComponent,
        canActivate: [AuthGuard],
        data: { breadcrumb: "TNTS" },
        children: [
          {
            path: 'Tools',
            component: CreateToolComponent,
            data: { breadcrumb: "Tools" },
          },
          {
            path: 'Administration',
            component: TntAdministrationComponent,
            canActivate: [AuthGuard],
            data: { breadcrumb: "Administration" },
            children: [
              {
                path: 'ToolIdentificationMatrix', component: ToolIdentificationMatrixComponent, data: { breadcrumb: "Tool Identification Matrix" },
                canActivate: [AuthGuard],
              },
              {
                path: 'ZoneSubZoneTitle', component: ZoneSubZoneTitleComponent, data: { breadcrumb: "Zone/SubZone/Title" },
              },
              {
                path: 'TransferTools', component: TransferToolsComponent, data: { breadcrumb: "Transfer Tools" },
              },
              {
                path: 'Toolownership', component: ToolOwnershipComponent, data: { breadcrumb: "Tool Ownership" },
              },
              {
                path: 'ArchiveTools', component: ArchiveToolsComponent, data: { breadcrumb: "Archived Tools" },
              },

              {
                path: 'TeamCenterLink', component: ToolTeamcenterLinkComponent, data: {
                  breadcrumb: "Tools Team Center Link"
                }
              },
              {
                path: 'Security', component: TntSecurityComponent, data: { breadcrumb: "Security" },
                children: [
                  {
                    path: '',
                    redirectTo: 'Security', pathMatch: 'full',
                  },
                ]
              },
            ]
          },
        ]
      },
      {
        path: 'TPRECM',
        children: [
          { path: 'Processes', component: TntComponent },
          { path: 'Kits', component: TntComponent },
          { path: 'Reports', component: TntComponent },
        ]
      },
    ]
  },
  {
    path: 'logged-out', component: LoggedOutComponent,
  },
  {
    path: 'unauthorized', component: UnauthorizedComponent,
  },
  { path: '**', component: NotFoundComponent, data: { breadcrumb: "404" } },

];


export const panelbarRouting: ModuleWithProviders<RouterModule> = RouterModule.forRoot(PanelbarRoutes, { useHash: true });

export const appRoutingProviders: any[] = [AuthGuard];

